import { ActionCreator, Action, Dispatch } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { IApplicationState } from '../store'
import GlnService from 'shared/service/GlnService'
import { IVolumewaardeModel } from 'shared/models/IVolumewaardeModel'
import { IResponseAction } from '../interfaces'

export enum Actions {
  GetVolumewaardeRequest = 'GetVolumewaardeRequest',
  GetVolumewaardeResponse = 'GetVolumewaardeResponse',
  PostVolumewaardeRequest = 'PostVolumewaardeRequest',
  PostVolumewaardeResponse = 'PostVolumewaardeResponse',
  DeleteVolumewaardeRequest = 'DeleteVolumewaardeRequest',
  DeleteVolumewaardeResponse = 'DeleteVolumewaardeResponse',
}

export interface IGetVolumewaardeRequestAction
  extends Action<Actions.GetVolumewaardeRequest> {
  payload: string
}
export interface IGetVolumewaardeResponseAction
  extends IResponseAction<Actions.GetVolumewaardeResponse> {
  payload: IVolumewaardeModel[]
}
export interface IPostVolumewaardeRequestAction
  extends Action<Actions.PostVolumewaardeRequest> {
  payload: IVolumewaardeModel
}
export interface IPostVolumewaardeResponseAction
  extends IResponseAction<Actions.PostVolumewaardeResponse> {
  payload: string
}
export interface IDeleteVolumewaardeRequestAction
  extends Action<Actions.DeleteVolumewaardeRequest> {
  payload: IVolumewaardeModel
}
export interface IDeleteVolumewaardeResponseAction
  extends IResponseAction<Actions.DeleteVolumewaardeResponse> {
  payload: string
}

export type VolumewaardeActions =
  | IGetVolumewaardeRequestAction
  | IGetVolumewaardeResponseAction
  | IPostVolumewaardeRequestAction
  | IPostVolumewaardeResponseAction
  | IDeleteVolumewaardeRequestAction
  | IDeleteVolumewaardeResponseAction

export const postVolumewaardeActionCreator: ActionCreator<
  ThunkAction<
    Promise<IPostVolumewaardeResponseAction>,
    IApplicationState,
    null,
    IPostVolumewaardeResponseAction
  >
> = (volumewaarde: IVolumewaardeModel) => {
  return async (dispatch: Dispatch, getState) => {
    const postDataAction: IPostVolumewaardeRequestAction = {
      type: Actions.PostVolumewaardeRequest,
      payload: volumewaarde,
    }
    dispatch(postDataAction)
    try {
      const result = await GlnService.postVolumewaarde(volumewaarde)
      const response: IPostVolumewaardeResponseAction = {
        success: result.success,
        errorMessage: result.errorMessage,
        payload: result.payLoad,
        type: Actions.PostVolumewaardeResponse,
      }
      console.log(response)
      return dispatch(response)
    } catch (e) {
      console.log(e)
      const errorResponse: IPostVolumewaardeResponseAction = {
        success: false,
        errorMessage: `Fout tijdens opslaan Volumewaarde: ${e.message}`,
        payload: null,
        type: Actions.PostVolumewaardeResponse,
      }

      return dispatch(errorResponse)
    }
  }
}

export const deleteVolumewaardeActionCreator: ActionCreator<
  ThunkAction<
    Promise<IDeleteVolumewaardeResponseAction>,
    IApplicationState,
    null,
    IDeleteVolumewaardeResponseAction
  >
> = (Volumewaarde: IVolumewaardeModel) => {
  return async (dispatch: Dispatch, getState) => {
    const postDataAction: IDeleteVolumewaardeRequestAction = {
      type: Actions.DeleteVolumewaardeRequest,
      payload: Volumewaarde,
    }
    dispatch(postDataAction)
    try {
      const result = await GlnService.verwijderVolumewaarde(Volumewaarde)
      const response: IDeleteVolumewaardeResponseAction = {
        success: result.success,
        errorMessage: result.errorMessage,
        payload: result.payLoad,
        type: Actions.DeleteVolumewaardeResponse,
      }

      return dispatch(response)
    } catch (e) {
      const errorResponse: IDeleteVolumewaardeResponseAction = {
        success: false,
        errorMessage: `Fout tijdens verwijderen Volumewaarde: ${e.message}`,
        payload: null,
        type: Actions.DeleteVolumewaardeResponse,
      }

      return dispatch(errorResponse)
    }
  }
}

export const getDataActionCreator: ActionCreator<
  ThunkAction<
    Promise<IGetVolumewaardeResponseAction>,
    IApplicationState,
    null,
    IGetVolumewaardeResponseAction
  >
> = (type: string, warehouseId: number) => {
  return async (dispatch: Dispatch, getState) => {
    const requestDataAction: IGetVolumewaardeRequestAction = {
      type: Actions.GetVolumewaardeRequest,
      payload: type,
    }
    dispatch(requestDataAction)

    try {
      const result = await GlnService.getVolumewaarden(type, warehouseId)
      const response: IGetVolumewaardeResponseAction = {
        success: result.success,
        errorMessage: result.errorMessage,
        payload: result.payLoad,
        type: Actions.GetVolumewaardeResponse,
      }

      if (
        (!result.success && result.errorCode === 404) ||
        (result.success && result.payLoad.length === 0)
      ) {
        response.success = false
        response.errorMessage = 'Geen volumewaarden gevonden'
      }

      return dispatch(response)
    } catch (e) {
      const errorResponse: IGetVolumewaardeResponseAction = {
        success: false,
        errorMessage: `Fout tijdens ophalen volumewaardes: ${e.message}`,
        payload: null,
        type: Actions.GetVolumewaardeResponse,
      }

      return dispatch(errorResponse)
    }
  }
}
